import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Form, TextInput, Select, Card, FormField, RadioButton, Text, RadioButtonGroup, TextArea } from "grommet";
import './MedicalEmergencyCreate.css';
import Symptoms from "./common/Symptoms";
import { FlightService } from "../../../../../../services/flights/flight.service";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import { NotificationHelper } from "../../../../../../util/notification/NotificationHelper";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { useUser } from "../../../../context/User/UserContext";
import { EndpointService } from "../../../../../../services/endpoint/endpoint.service";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from 'mobx-react';
import { MedicalEmergencyStatus } from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import { Mixpanel } from "../../../../../../util/Helper";
import { Close } from "grommet-icons";
import usersService from "../../IAM/Users/users.service";

const PassengerDetail = observer(({ onDone }) => {
    const { rootStore } = useStore();

    // const [isPatientConscious,setisPatientConscious] = useState(rootStore.emsStore.getPassengerConscious ? "Yes" : "No ")
    // const [isPatientConscious,setisPatientConscious] = useState("")

    const RenderItem = ({ item, index }) => {
        return (
            <span onClick={() => selectSymptomFun(item)} style={{ borderColor: rootStore.emsStore.getSelectedSymptoms.includes(item) ? '#357EFF ' : '#f2f7fc ', color: rootStore.emsStore.getSelectedSymptoms.includes(item) ? "#357EFF" : "#000" }} className="symptomChip">
                {item} {rootStore.emsStore.getSelectedSymptoms.includes(item)}
            </span>
        );
    }
   
    // Calling get passenger function
    useEffect(() => {
      getPassengers();

      return () => {
        rootStore.emsStore.handlePassengerName("");
        rootStore.emsStore.handleSelectedAge(null);
        rootStore.emsStore.handleSelectedGender("");
      }
    }, []);

    // Get passenger related by org id
    const getPassengers = async () => {
      try {
        rootStore.loadingStore.setShowLoader(true);
        const PassengerData = await PassengerService.listAllPassenger(rootStore.emsStore.getSelectedOrgId);
        const filterPassenger = PassengerData.filter((item) => item.name.replace(/\s+/g, '').includes(rootStore.emsStore.getPassengerName.replace(/\s+/g, '')) && rootStore.emsStore.getPassengerName != "");
        rootStore.emsStore.handleFilterPassengerList2(filterPassenger);
        rootStore.emsStore.handlePassengerList2(PassengerData);
        rootStore.loadingStore.setShowLoader(false);
      } catch (error) {
        console.error("Error fetching flights:", error);
      }
    };

    // onChange passenger name
    const onChangePassengerName = (event) => {
        rootStore.emsStore.handleSelectedPassengerId(null);
        rootStore.emsStore.handleSelectedAge(0);
        rootStore.emsStore.handleSelectedGender("");
        rootStore.emsStore.handlePassengerName(event.target.value)
        const passengerList = [...rootStore.emsStore.getPassengerList2];
        rootStore.emsStore.handlePassengerNameError(false)
        if(event.target.value.trim()!==""){
            const filterPassenger = passengerList.filter((item) => item.name.toLowerCase().replace(/\s+/g, '').includes(event.target.value.toLowerCase().replace(/\s+/g, '')) && event.target.value != "");
            rootStore.emsStore.handleFilterPassengerList2(filterPassenger);
        }else{
            rootStore.emsStore.handleFilterPassengerList2([])
        }
    }

    // onPassenger select
    const onPassengerSelect = async (id) => {
        console.log("Selected passenger id", id);
        try {
            rootStore.emsStore.handleSelectedPassengerId(id);
            let passenger = await PassengerService.getPassenger(id);
            rootStore.emsStore.handlePassengerName(passenger.name);
            rootStore.emsStore.handleSelectedAge(passenger.age);
            rootStore.emsStore.handleSelectedGender(passenger.gender == "OTHERS" ? "Other" : passenger.gender.charAt(0).toUpperCase() + passenger.gender.slice(1).toLowerCase());
            rootStore.emsStore.handleFilterPassengerList2([]);
        } catch (error) {
            console.error("Error in feting passenger", error);
        }
    }

    let passengerList = rootStore.emsStore.getFilterPassengerList2.map((passenger, index) => {
        return (
            <li onClick={() => onPassengerSelect(passenger.passengerId)}>{passenger.name}</li>
        );
    });
    

    const otherSymptomFun = (e) => {
        rootStore.emsStore.handleOtherSympInput(!rootStore.emsStore.getOtherSympInput);
    }

    const selectSymptomFun = (symp) => {
        rootStore.emsStore.handleSelectedSymptoms(symp);
    }

    useEffect(() => {
    }, [rootStore.emsStore.getSelectedSymptoms])
    const [filteredOptions, setFilteredOptions] = useState(
        Array.from({ length: 130 }, (_, i) => ({ value: i + 1, label: i + 1 }))
    );
    
    const handleSearch = (value) => {
        if (value) {
            const filtered = Array.from({ length: 130 }, (_, i) => ({ value: i + 1, label: i + 1 })).filter(
              (option) => option.label.toString().includes(value.toString())
            );
            setFilteredOptions(filtered);
        } else {
            const filtered = Array.from({ length: 130 }, (_, i) => ({ value: i + 1, label: i + 1 })).filter(
                (option) => option.label.toString().includes(value.toString())
              );
              setFilteredOptions(filtered);
        }
    };      
    // useEffect(()=>{
    //     rootStore.emsStore.handlePassengerConscious(isPatientConscious)
    // },[isPatientConscious])
    // const handlePatientConscious = (e) =>{
    //     setisPatientConscious(e.target.value);
    // }

    return (
        <div className="create-medical-container">
            <Card style={{ position: 'relative', height: "100%" }}>
                <h1 className="page-headeing">Initiate Medical Event</h1>
                <Form validate="change" className="passenger-detail-form">
                    <div className="input_row second-row">
                        <div className="input_row_items" style={{position: 'relative'}}>
                            <FormField
                                className="add-passenger-form-F1"
                                name="passengerName"
                                htmlFor="passenger-name-id"
                                placeholder="Passenger’s Name"
                                validate={[
                                    {
                                    regexp: /^[a-zA-Z\s]+$/, 
                                    message: "Passenger’s name can only contain letters and spaces.",
                                    }
                                ]}
                                >
                            <div className="input_title">Passenger's Name</div>
                            <TextInput id="passenger-name-id" name="passengerName" className="name_input" type="text" placeholder="Enter here" value={rootStore.emsStore.getPassengerName} onChange={onChangePassengerName} maxLength={100} />
                            {/*
                            {
                                rootStore.emsStore.getFilterPassengerList2.length > 0
                                    &&
                                <div className="passenger-exist-box">
                                    <ul>
                                        {passengerList}
                                    </ul>
                                </div>
                            }
                            */}
                            </FormField>
                        </div>
                        <div className="input_row_items">
                            <FormField className="add-passenger-form-F2">
                            <div className="input_title">Passenger's Age</div>
                            <TextInput
                                className="name_input"
                                type="number"
                                min={0}
                                max={120}
                                style={{ opacity: rootStore.emsStore.getSelectedPassengerId !== null ? 0.3 : 1 }}
                                readOnly={rootStore.emsStore.getSelectedPassengerId !== null}
                                placeholder="Enter here"
                                value={rootStore.emsStore.getSelectedAge}
                                onChange={(event) => {
                                    const value = Number(event.target.value);

                                    // Ensure age cannot go above 120
                                    if (value <= 120) {
                                    rootStore.emsStore.handleSelectedAge(value);
                                    }
                                }}
                                />

                            </FormField>
                        </div>
                        {/*
                        <div className="input_row_items">
                            <div className="input_title">Passenger's Age</div>
                            <Select
                                className="name_input"
                                style={{opacity: rootStore.emsStore.getSelectedPassengerId !== null ? .3 : 1,padding:'0px',height:"30px"}}
                                readOnly={rootStore.emsStore.getSelectedPassengerId !== null}
                                disabled={rootStore.emsStore.getSelectedPassengerId !== null}
                                value={rootStore.emsStore.getSelectedAge}
                                required
                                onChange={({ option }) => rootStore.emsStore.handleSelectedAge(option.value)}
                                options={filteredOptions}
                                placeholder="Enter here"
                                id="age-select"
                                aria-label="Select passenger age"
                                onSearch={(value) => handleSearch(value)}
                                onBlur={() => handleSearch("")}
                                searchPlaceholder="search..."
                            />
                        </div>
                        */}
                    </div>
                            {
                                rootStore.emsStore.getPassengerNameError && <p style={{padding:"10px",fontSize:'14px',color:"red",marginTop:"-33px",marginLeft:"13px"}}>Please enter passenger's name.</p>
                            }
                    <div className="gender-selection-outer" style={{ borderBottom: "1px solid #F6F8FF" }}>
                        <div className="input_row" style={{ paddingTop: 0 }}>
                            <div className="input_row_items" style={{width: '26%'}}>
                                <Box className="">
                                    <div className="input_title">Is the patient conscious?</div>
                                    <RadioButtonGroup
                                        name="doc"
                                        options={['Yes', 'No']}
                                        // value={isPatientConscious}
                                        onChange={(event) => rootStore.emsStore.handlePassengerConscious(event.target.value)}
                                        // onChange={(event) => handlePatientConscious(event)}
                                        className="genderContainer"
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                    <div className="gender-selection-outer" style={{ borderBottom: "1px solid #F6F8FF" }}>
                        <div className="input_row">
                            <div className="input_row_items">
                                <Box className="">
                                    <div className="input_title">Passenger's Gender</div>
                                    <RadioButtonGroup
                                        name="doc"
                                        options={['Male', 'Female', "Other"]}
                                        value={rootStore.emsStore.getSelectedGender}
                                        onChange={(event) => {
                                            if(rootStore.emsStore.getSelectedPassengerId == null) {
                                                rootStore.emsStore.handleSelectedGender(event.target.value);
                                            }
                                        }}
                                        className="genderContainer"
                                        style={{opacity: rootStore.emsStore.getSelectedPassengerId !== null ? .3 : 1}}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                    <div className="objc_btn_main">
                        <span className="objc_title">Passenger Complaints and Observations</span>

                        <div className="btn_group_main">
                            {
                                rootStore.emsStore.commonSymptompList.map((symptom, index) => {
                                    return (


                                        <RenderItem item={symptom} index={index} />
                                    )
                                })
                            }
                            <Text style={{ display: 'inline-block', borderColor: rootStore.emsStore.getOtherSympInput ? '#357EFF' : "#F2F7FF" }} onClick={otherSymptomFun}>
                                <div style={{ backgroundColor: rootStore.emsStore.getOtherSympInput ? '#1FB5FC' : 'rgba(31, 181, 252, 0.1)', color: rootStore.emsStore.getOtherSympInput ? "#357EFF" : "#000" }} className="symptomChip">
                                    Others
                                </div>
                            </Text>
                            {
                                rootStore.emsStore.getOtherSympInput &&
                                <Box className="textArea">
                                    <TextArea
                                        placeholder="Type symptoms here"
                                        resize={false}
                                        value={rootStore.emsStore.getOtherSymp}
                                        onChange={event => rootStore.emsStore.handleOtherSymptoms(event.target.value)}
                                    />
                                </Box>
                            }
                        </div>
                    </div>

                    <div style={{ textAlign: 'end',margin: "0 20px 20px 0" }}>
                        <Button 
                            className="next_btn" 
                            type="button" 
                            primary label="Submit" 
                            onClick={() => onDone(rootStore.emsStore.getSelectedSymptoms, rootStore.emsStore.getOtherSymp)} 
                            color={"brand-1"} 
                        />
                    </div>

                </Form>
            </Card>
        </div >
    );
});

export default PassengerDetail;